import Base from 'app/models/base';

export default Base.extend({
  parse(attrs) {
    const thisAttrs = { ...attrs };

    this.collection = thisAttrs.collection;
    delete thisAttrs.collection;
    return thisAttrs;
  },

  initialize(options) {
    if (!this.get('pageSize')) {
      this.set('pageSize', 20);
    }
    this.listenTo(this.collection, 'filtered', this.resetPagination);
    this.listenTo(this.collection, 'sync', this.collectionUpdated);
    this.resetPagination();

    if (options.buildParams) {
      this.buildParams = options.buildParams.bind(this);
    }
  },

  fetchCollection() {
    this.collection.fetch({
      reset: true,
      paginationParams: this.buildParams ? this.buildParams() : {
        before_id: this.get('beforeId'),
        after_id: this.get('afterId'),
        page_size: this.get('pageSize'),
      },
    });
  },

  onFirstPage() {
    return this.get('currentPage') === 0;
  },

  onLastPage() {
    return this.get('currentPage') === this.get('lastPage');
  },

  isLastPageUnknown() {
    return (typeof this.get('lastPage') === 'undefined');
  },

  currentIsLastPage() {
    this.set('lastPage', this.get('currentPage'));
  },

  resetPagination() {
    this.set('beforeId', undefined);
    this.set('afterId', undefined);
    this.set('currentPage', 0);
    this.set('lastPage', undefined);
    this.fetchCollection();
  },

  collectionUpdated() {
    const length = this.collection.length;
    if ((!this.collection.hasMore && !this.onFirstPage() && this.isLastPageUnknown()) || length === 0 || length < this.get('pageSize')) {
      this.currentIsLastPage();
    }
    this.trigger('updateButtons');
  },

  pageBack() {
    if (!this.onFirstPage()) {
      const latestRecord = this.collection.models[0];
      this.set('beforeId', undefined);
      this.set('afterId', (latestRecord ? latestRecord.id : this.get('afterId')));
      this.set('currentPage', this.get('currentPage') - 1);
      this.fetchCollection();
    }
  },

  pageNext() {
    if (!this.onLastPage()) {
      const earliestRecord = this.collection.models[this.collection.models.length - 1];
      this.set('beforeId', (earliestRecord ? earliestRecord.id : this.get('beforeId')));
      this.set('afterId', undefined);
      this.set('currentPage', this.get('currentPage') + 1);
      this.fetchCollection();
    }
  },
});



// WEBPACK FOOTER //
// ./app/models/paginator.js